import router from '@/router'
import { get, execute } from '@/api/acessorelatorio'
import './stimulsoftAdapter'

const state = {
  relatorio: {
    estado: false,
    schema: {}
  },
  report: {
    estado: false,
    report: false,
    dados: false
  },
  editaRelatorio: {
    report: null,
    function: null
  }
}

const mutations = {
  ABRERELATORIO (state, dados) {
    state.relatorio.estado = true
    state.relatorio.schema = dados
  },
  FECHARELATORIO (state) {
    state.relatorio.estado = false
    state.relatorio.schema = false
  },
  ABREREPORT (state, context) {
    state.report.estado = true
    state.report.report = context.report
    state.report.dados = context.dados
  },
  FECHAREPORT (state) {
    state.report.estado = false
    state.report.report = false
    state.report.dados = false
  },
  EDITARELATORIO (state, context = {}) {
    state.editaRelatorio.report = context.layout || null
    state.editaRelatorio.function = context.function || null
  }
}

const actions = {
  async openPrint ({ dispatch }, { id, filtros }) {
    let item = await get(id)
    let dados = await execute(item.urlDados, filtros)
    return dispatch('report', { report: item.report, dados })
  },
  async open ({ commit }, id) {
    let item = await get(id)
    commit('ABRERELATORIO', item)
  },
  close ({ commit }) {
    commit('FECHARELATORIO')
  },
  report ({ commit }, dados) {
    commit('ABREREPORT', dados)
  },
  closeReport ({ commit }) {
    commit('FECHAREPORT')
  },
  editaRelatorio ({ commit }, context) {
    commit('EDITARELATORIO', context)
  },
  async saveRelatorio ({ state, dispatch }, report) {
    if (state.editaRelatorio.function) await state.editaRelatorio.function(report)
    await dispatch('closeRelatorio')
  },
  async closeRelatorio ({ commit, dispatch }) {
    commit('EDITARELATORIO')
    let voltar = await dispatch('delViewURL', '/edita-relatorio', { root: true })
    if (voltar) router.push(voltar.path)
    else router.push('/')
  }
}

export default { namespaced: true, state, mutations, actions }
